import { DuplicateChecksModalProps } from 'components/EmployeeDetails/StatutoryContributions/components/DuplicateChecksModal';
import { SalaryStructureComponent } from 'components/SalaryStructure/types';
import { getAppErrorDetails } from 'utils/AppError';

export const getGeneratedEmail = (orgId?: number) => {
  const timestamp = new Date().getTime();
  const email = `auto+${orgId}+${timestamp}@opfin.com`;
  return email;
};

export const getDuplicateDetails = (error: any) => {
  return error
    ? (getAppErrorDetails(error)?.otherDetails?.response?.errors?.[0]?.extensions?.response?.body
        ?.extraDetails as DuplicateChecksModalProps['details'])
    : undefined;
};

export const onboardingErrorMessages = {
  panExists: 'PAN already exists',
};

export const isWholeNumber = (value: string) => {
  return /^\d+(\.0+)?$/.test(value);
};

export const validateFormuals = (components: SalaryStructureComponent[]): string[] => {
  let errors: string[] = [];

  for (let comp of components) {
    if (comp.valueType === 'SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_SA') {
      continue;
    }

    if (!comp.formula || (comp.formula && !isWholeNumber(comp.formula))) {
      errors.push(
        `${
          comp?.salaryComponent?.name || 'Salary Structure Component'
        } formula must be a whole number`,
      );
    }
  }
  return errors;
};
